import React                from "react";
import PropTypes            from "prop-types";
import { connect }          from "react-redux";
import Utils                from "dashboard/dist/Utils/Utils";

// Components
import EditDialog           from "dashboard/dist/Components/EditDialog";
import AvatarList           from "dashboard/dist/Components/AvatarList";
import AvatarItem           from "dashboard/dist/Components/AvatarItem";

// Actions
import {
    fetchTicketAssign, assignTicket,
} from "Actions/Admin/Ticket/TicketActions";



/**
 * The Ticket Assign Dialog
 */
class TicketAssign extends React.Component {
    // The Initial Data
    initialData = {
        ticketID   : 0,
        adminID    : 0,
        forSupport : false,
    }

    // The Current State
    state = {
        loading : false,
        data    : { ...this.initialData },
        errors  : {},
    }



    /**
     * Get the Data when the Element ID changes
     * @param {Object} prevProps
     * @returns {Void}
     */
    componentDidUpdate(prevProps) {
        const { forSupport, open, edition, elemID, elem, fetchTicketAssign } = this.props;
        let loading = false;
        let data    = null;

        // Dialog Opens
        if (open && !prevProps.open) {
            data = { ...this.initialData };
            // Load new data
            if (elemID) {
                fetchTicketAssign(elemID, forSupport);
                loading = true;
            }

        // Data Updated
        } else if (prevProps.edition !== edition) {
            data = Utils.extend(this.initialData, elem);
            data.forSupport = forSupport;
        }

        // Set the State
        if (data) {
            this.setState({ data, loading, errors : {} });
        }
    }

    /**
     * Handles the User Change
     * @param {Number} adminID
     * @returns {Void}
     */
    handleUser = (adminID) => {
        this.setState({
            data : { ...this.state.data, adminID },
        });
    }

    /**
     * Handles the Submit
     * @returns {Promise}
     */
    handleSubmit = async () => {
        const { data, loading } = this.state;
        if (!loading) {
            this.setState({ loading : true, errors : {} });
            try {
                await this.props.assignTicket(data);
                this.setState({ loading : false });
                this.props.onSubmit();
            } catch (errors) {
                this.setState({ loading : false, errors });
            }
        }
    }



    /**
     * Does the Render
     * @returns {Object}
     */
    render() {
        const { forSupport, open, onClose, admins } = this.props;
        const { data, loading                     } = this.state;

        const prefix = forSupport ? "SUPPORT_" : "TICKETS_";

        return <EditDialog
            open={open}
            icon="assign"
            title={`${prefix}ASSIGN_TITLE`}
            onSubmit={this.handleSubmit}
            onClose={onClose}
            isLoading={loading}
            withSpacing={false}
            isNarrow
        >
            <AvatarList>
                {admins.map((elem) => <AvatarItem
                    key={elem.credentialID}
                    isSelected={data.adminID === elem.credentialID}
                    name={elem.credentialName}
                    data={elem}
                    email={elem.email}
                    onClick={() => this.handleUser(elem.credentialID)}
                />)}
            </AvatarList>
        </EditDialog>;
    }



    /**
     * The Property Types
     * @typedef {Object} propTypes
     */
    static propTypes = {
        fetchTicketAssign : PropTypes.func.isRequired,
        assignTicket      : PropTypes.func.isRequired,
        forSupport        : PropTypes.bool.isRequired,
        open              : PropTypes.bool.isRequired,
        onClose           : PropTypes.func.isRequired,
        onSubmit          : PropTypes.func.isRequired,
        edition           : PropTypes.number.isRequired,
        admins            : PropTypes.array.isRequired,
        elem              : PropTypes.object.isRequired,
        elemID            : PropTypes.number,
    }

    /**
     * Maps the State to the Props
     * @param {Object} state
     * @returns {Object}
     */
    static mapStateToProps(state) {
        return {
            edition : state.ticket.edition,
            admins  : state.ticket.admins,
            elem    : state.ticket.elem,
        };
    }
}

export default connect(TicketAssign.mapStateToProps, {
    fetchTicketAssign, assignTicket,
})(TicketAssign);
